import { render } from "./Panel.vue?vue&type=template&id=dde38cce&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=dde38cce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dde38cce"

export default script